import React from "react";
import "./index.css";

const ScopeComponent = ({
  label,
  value,
  onChange,
  isEditing,
  customStyle,
  isDisabled,
  errorMessage,
  bgColorLabel,
  colorLabel,
}) => (
  <div className="scope-container" style={customStyle}>
    <div
      className="scope-cloud"
      style={{ backgroundColor: bgColorLabel, color: colorLabel }}
    >
      {label}
    </div>
    <div className="scope-div-input">
      {isEditing ? (
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={isDisabled}
        />
      ) : (
        <div className="display-value">{value}</div>
      )}
      <p>tCO₂e</p>
    </div>

    {errorMessage && <div className="error-message">{errorMessage}</div>}
  </div>
);

export default ScopeComponent;
